import {
    PortfolioGetCentralCancellationPolicyOverviewEntries,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';

export const useCentralCancellationPolicyOverviewEntries = (
    params: PortfolioGetCentralCancellationPolicyOverviewEntries
) => useRepositorySuspenseQuery('portfolioCentralCancellationPolicies', 'getOverviewEntries', params);
